import React from "react";
import {
  getNameFromID,
  getTwelveHourAMPMTime,
  parseDate,
} from "../../util/FormatUtil";
import Overlay from "../Overlay";
import moment from "moment-timezone";
import SimpleTable from "../tables/SimpleTable";
import PodSched from "../../types/PodSched";
import { Column } from "../tables/TableBase";
import { Sorter, TableOrder } from "../../sorting/Sorter";
import PodAPI from "../../network/PodAPI";
import ServicesAPI from "../../network/ServicesAPI";

interface AdminHomePageState {
  showLoading?: boolean;
  tableData: any[];
  totalPods?: number;
  direction?: TableOrder;
  services?;
}

export default class AdminHomePage extends React.Component<
  any,
  AdminHomePageState
> {

  constructor(props) {
    super(props);
    this.state = {
      showLoading: false,
      tableData: [],
      totalPods: 0,
      direction: "asc",
      services: [],
    };
  }

  componentDidMount(): void {
    this.setState({ showLoading: true }, async () => {
      ServicesAPI.getAllServicesForApptForm().then((data) => {
        this.setState({
          services: data.data.map((s) => ({ label: s.Name, value: s.ID })),
        });
      });
      let response = await PodAPI.searchPodsForHomePage();
      this.setState({
        showLoading: false,
        tableData: response.table_data,
        totalPods: response.total,
      });
    });
  }

  useSorter(col: Column) {
    let sorter = new Sorter<PodSched>()
      .withRawSorterFunc("Facility.FacilityName", (a, b) => {
        let aFacility = a.Facility.FacilityName;
        let bFacility = b.Facility.FacilityName;
        return aFacility.localeCompare(bFacility);
      })
      .withRawSorterFunc("BreakTimes", (a, b) => {
        let aBreakTimes = a.PodBreaks.length > 0 ? 1 : 0;
        let bBreakTimes = b.PodBreaks.length > 0 ? 1 : 0;
        return aBreakTimes - bBreakTimes;
      })
      .withRawSorterFunc("Time", (a, b) => {
        return moment(a.StartTime, "hh:mm a").diff(
          moment(b.StartTime, "hh:mm a")
        );
      });

    this.setState({
      tableData: sorter.sortByKey(
        this.state.tableData,
        col.key as keyof PodSched,
        this.state.direction
      ),
      direction: this.state.direction === "asc" ? "desc" : "asc",
    });
  }

  getNextWeek() {
    let nextWeek = moment().add(7, "days").format("MM/DD/YYYY");
    return nextWeek;
  }

  render():
    | React.ReactElement
    | string
    | number
    | {}
    | React.ReactNodeArray
    | React.ReactPortal
    | boolean
    | null
    | undefined {
    let today = moment().format("MM/DD/YYYY");
    let nextweek = this.getNextWeek();

    return (
      <React.Fragment>
        <Overlay show_loading={this.state.showLoading} />
        <div className="container-fluid">
          <div className={"row"}>
            <div className="col-12 pt-2">
              {this.state.totalPods > 0 ? (
                <div className="card mt-2">
                  <div className="card-header verlag-bold">
                    <div className="row">
                      <div className="col-12 col-lg-4 text-center text-lg-left">
                        <h4>Weekly Schedules
                        </h4>
                      </div>
                      <div className="d-none d-lg-block col-lg-4 text-lg-center">
                        <img
                          src={"https://storage.googleapis.com/streamline-bucket/ITGStar.png"}
                          style={{ height: "40px" }}
                          alt={"logo"}
                        />
                      </div>
                      <div className="col-12 col-lg-4 text-center text-lg-right">
                        <h4>
                          {today} - {nextweek}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                ) : (
                <div className="col-12 pt-2">
                  <div className="card mt-2">
                    <div className="card-header verlag-bold">
                      <div className="row">
                        <div className="col-12 col-lg-4 text-center text-lg-left">
                          <h5>No schedules showing for this week</h5>
                        </div>
                        <div className="d-none d-lg-block col-lg-4 text-lg-center">
                          <img
                            src={"https://storage.googleapis.com/streamline-bucket/ITGStar.png"}
                            style={{ height: "40px" }}
                            alt={"logo"}
                          />
                        </div>
                        <div className="col-12 col-lg-4 text-center text-lg-right">
                          <h4>
                            {today} - {nextweek}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                )
              }

              {/* phone */}
              {this.state.totalPods > 0 ? (
                <div className="d-block d-md-none">
                <SimpleTable
                  table_data={this.state.tableData}
                  columns={[
                    { label: "Pod#", key: "ID" },
                    {
                      label: "Date",
                      key: "TestDate",
                      formatFunc: parseDate,
                    },
                    {
                      label: "Time",
                      key: "Time",
                      rawFormat: (val) => {
                        return (
                          <div>
                            {getTwelveHourAMPMTime(val.StartTime)} -{" "}
                            {getTwelveHourAMPMTime(val.EndTime)}
                          </div>
                        );
                      },
                    },
                    {
                      label: "Available Appts",
                      key: "Available",
                      rawFormat: (val) => {
                        return (
                          <div>
                            {val.Available} / {val.Total}
                          </div>
                        );
                      },
                    },
                    {
                      label: "Checked In/Booked",
                      key: "CheckedIn",
                      rawFormat: (val) => {
                        return (
                          <div>
                            {val.CheckedIn} / {val.Booked}
                          </div>
                        );
                      },
                    },
                  ]}
                  columnClickedCallback={(col) => {
                    this.useSorter(col);
                  }}
                />
              </div>
              ) : (
                <div className="d-none"></div>
              )}



              {/* tablet */}
              {this.state.totalPods > 0 ? (
                <div className="d-none d-md-block d-lg-none">
                <SimpleTable
                      table_data={this.state.tableData}
                      columns={[
                        { label: "Schedule#", key: "ID" },
                        {
                          label: "Date",
                          key: "TestDate",
                          formatFunc: parseDate,
                        },
                        {
                          label: "Time",
                          key: "Time",
                          rawFormat: (val) => {
                            return (
                              <div>
                                {getTwelveHourAMPMTime(val.StartTime)} -{" "}
                                {getTwelveHourAMPMTime(val.EndTime)}
                              </div>
                            );
                          },
                        },
                        {
                          label: "Services",
                          key: "Service",
                          rawFormat: (v) => {
                            let serviceIDs = v.ServiceIDs
                              ? JSON.parse(v.ServiceIDs)
                              : [];
                            let serviceName = [];
                            serviceIDs.map((s) => {
                              return serviceName.push(
                                getNameFromID(s, this.state.services)
                              );
                            });
                            return (
                              serviceName && serviceName.map((s) => <p className="mb-0">{s}</p>)
                            );
                          },
                        },
                        { label: "Facility", key: "Facility.FacilityName" },
                        {
                          label: "Available Appts",
                          key: "Available",
                          rawFormat: (val) => {
                            return (
                              <div>
                                {val.Available} / {val.Total}
                              </div>
                            );
                          },
                        },
                        {
                          label: "Checked In/Booked",
                          key: "CheckedIn",
                          rawFormat: (val) => {
                            return (
                              <div>
                                {val.CheckedIn} / {val.Booked}
                              </div>
                            );
                          },
                        },
                      ]}
                      columnClickedCallback={(col) => {
                        this.useSorter(col);
                      }}
                    />
                    </div>
              ) : (
                <div className="d-none"></div>
              )}
                  {/* desktop */}
                  {this.state.totalPods > 0 ? (
                    <div className="d-none d-lg-block">
                      <SimpleTable
                        table_data={this.state.tableData}
                        columns={[
                          { label: "Schedule#", key: "ID" },
                          {
                            label: "Date",
                            key: "TestDate",
                            formatFunc: parseDate,
                          },
                          {
                            label: "Time",
                            key: "Time",
                            rawFormat: (val) => {
                              return (
                                <div>
                                  {getTwelveHourAMPMTime(val.StartTime)} -{" "}
                                  {getTwelveHourAMPMTime(val.EndTime)}
                                </div>
                              );
                            },
                          },
                          {
                            label: "Services",
                            key: "Service",
                            rawFormat: (v) => {
                              let serviceIDs = v.ServiceIDs
                                ? JSON.parse(v.ServiceIDs)
                                : [];
                              let serviceName = [];
                              serviceIDs.map((s) => {
                                serviceName.push(
                                  getNameFromID(s, this.state.services)
                                );
                              });
                              return (
                                serviceName && serviceName.map((s) => <p className="mb-0">{s}</p>)
                              );
                            },
                          },
                          { label: "Facility", key: "Facility.FacilityName" },
                          {
                            label: "Available Appts",
                            key: "Available",
                            rawFormat: (val) => {
                              return (
                                <div>
                                  {val.Available} / {val.Total}
                                </div>
                              );
                            },
                          },
                          {
                            label: "Checked In/Booked",
                            key: "CheckedIn",
                            rawFormat: (val) => {
                              return (
                                <div>
                                  {val.CheckedIn} / {val.Booked}
                                </div>
                              );
                            },
                          },
                        ]}
                        columnClickedCallback={(col) => {
                          this.useSorter(col);
                        }}
                      />
                    </div>
                  ) : (
                    <div className="d-none"></div>
                  )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
